module.exports = __webpack_public_path__ + "img/甜点蛋糕店图片生成.42769ce6.png";